import React from "react";
import IActionBox from "./IActionBox";
import { classNames as cn } from "@features/utils/reactFunctions";
import Edit from "./pencil.svg";

import * as elements from "@appStyles/_elements.module.scss";
import * as companyStyles from "@company/AppStyle.module.scss";
import * as style from "./ActionBoxStyle.module.scss"

const ActionBox: React.FunctionComponent<IActionBox> = (props) => {
  const renderRadioBox = () => (
    <div
      className={cn(
        style.box,
        elements.customRadio,
        props.className,
        props.radioAttr!.checked && style.boxActive
      )}
    >
      <input type="radio" id={props.radioKey} {...props.radioAttr} />
      <label htmlFor={props.radioKey} className={style.labelReversed}>
        <div className={style.boxDetails}>
          <div className={style.first}>{props.headline}</div>
          {props.text}
        </div>
      </label>
    </div>
  );

  const renderBox = () => {
    const renderEditButton = (
      <button
        onClick={props.editClick}
        className={cn(companyStyles.editButton, style.editBtn)}
      >
        <Edit />
      </button>
    );

    const renderCancelButton = (
      <button
        onClick={props.cancelClick}
        className={cn(elements.cancelButton, elements.cancelButtonBig)}
      />
    );

    const renderArrowIcon = (
      <button
        onClick={props.editClick}
        className={cn(
          elements.arrowIcon,
          elements.arrowIconBig,
          style.mr10,
          "fa fa-angle-right"
        )}
      />
    );

    return (
      <div
        className={cn(
          style.box,
          props.className,
          (props.type === "view_cancel" || props.isRequested) &&
            style.boxRequested
        )}
      >
        <div className={style.boxDetails}>
          <div className={style.first}>{props.headline}</div>
          {props.text}
        </div>

        {props.type === "edit" && props.editClick && (
          <div className={style.boxAction}>{renderEditButton}</div>
        )}

        {props.type === "edit_cancel" && (
          <div className={style.boxAction}>
            {renderEditButton}
            {renderCancelButton}
          </div>
        )}

        {props.type === "view" && (
          <div className={style.boxAction}>{renderArrowIcon}</div>
        )}

        {props.type === "view_cancel" && (
          <div className={style.boxAction}>
            {renderArrowIcon}
            {renderCancelButton}
          </div>
        )}
      </div>
    );
  };

  return props.type === "radio" ? renderRadioBox() : renderBox();
};

export default ActionBox;
